module.exports = __webpack_public_path__ + "static/media/ProblemSolving.4f223eea.mp3";